// When Enter sends a composer's text, and when it adds a line.

/** Whether this is a touch screen with no mouse or trackpad (a phone, not an iPad on its keyboard). */
function touchOnly() {
  return typeof window !== "undefined" && !window.matchMedia("(any-pointer: fine)").matches;
}

/**
 * Whether a key press sends: Enter, not Shift+Enter or one that ends a word
 * being composed, and not on a touch screen, where return adds a line.
 */
export function enterSends(
  event: { key: string; shiftKey: boolean; nativeEvent: { isComposing: boolean } },
  touch = touchOnly(),
) {
  return event.key === "Enter" && !event.shiftKey && !event.nativeEvent.isComposing && !touch;
}
